import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

const testIsFalsyOrTypeName = (
    value: string | number | null | undefined | boolean
) => {
    if (
        value === 'ListingAnalyticsEcommerce' ||
        value === 'ListingAnalyticsTaxonomy'
    ) {
        return false;
    }
    return identity(value);
};

const removeNullAnalyticValues = (
    value: Record<string, string | number | null | undefined | boolean>
) => pickBy(value, testIsFalsyOrTypeName);

export default removeNullAnalyticValues;
